<freud-accordion>
	<freud-accordion-tab [selected]="isOpen" [header]="'PROMPTUARY.QUALITY_MODAL.RECOMMENDATIONS.TITLE' | translate">
		<div class="zk-flex zk-pt-2 zk-gap-2">		
			<p id="recommendations-first" freud-typography fontType="bodyRegular1-5">
				&#8226; {{ 'PROMPTUARY.QUALITY_MODAL.RECOMMENDATIONS.FIRST' | translate }}
			</p>
		</div>
		<div class="zk-flex zk-pt-2 zk-gap-2">
			<p id="recommendations-second" freud-typography fontType="bodyRegular1-5">
				&#8226; {{ 'PROMPTUARY.QUALITY_MODAL.RECOMMENDATIONS.SECOND' | translate }}
			</p>
		</div>
		<div class="zk-flex zk-pt-2 zk-gap-2">
			<p id="recommendations-third" freud-typography fontType="bodyRegular1-5">
				&#8226; {{ 'PROMPTUARY.QUALITY_MODAL.RECOMMENDATIONS.THIRD' | translate }}
			</p>
		</div>
	</freud-accordion-tab>
</freud-accordion>
